module.exports = __webpack_public_path__ + "img/base_activites_aviron.15bf456e.svg";